import React, { useState, useContext, useEffect, useRef } from 'react'
import {
	SNavbar,
	SLeftContainer,
	SRightContainer,
	SNavbarExtendedContainer,
	SNavbarInnerContainer,
	SNavbarLinkContainer,
	SNavbarLink,
	STCREFFERALNavbarLink,
	NavbarDonatePopup,
	SLogo,
	SOpenLinksButton,
	SThemeModeIconContainer,
	SNavbarLinkExtended
} from './styles'
import { mainLogoWhiteSVG, mainLogoBlackSVG } from '../../assets'
import { ThemeContext } from '../../App'
import { MdOutlineLightMode, MdOutlineDarkMode } from 'react-icons/md'
import Popup from 'reactjs-popup'
import BuyMeACoffePopup from '../Popup/Popup'
import { FiCoffee } from 'react-icons/fi'

function Navbar() {
	const [extendNavbar, setExtendNavbar] = useState(false)
	const { setTheme, theme } = useContext(ThemeContext)
	const wrapperRef = useRef(null)
	useEffect(() => {
		function handleClickOutside(event) {
			if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
				if (extendNavbar) {
					setExtendNavbar((curr) => !curr)
				}
			}
		}
		// Bind the event listener
		document.addEventListener('mousedown', handleClickOutside)
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [extendNavbar, wrapperRef])

	return (
		<SNavbar extendNavbar={extendNavbar} ref={wrapperRef}>
			<SNavbarInnerContainer>
				<SLeftContainer>
					{theme === 'dark' && <SLogo src={mainLogoWhiteSVG}></SLogo>}
					{theme === 'light' && <SLogo src={mainLogoBlackSVG}></SLogo>}
					<SNavbarLinkContainer>
						<SNavbarLink to="/tools">Tools</SNavbarLink>

						<Popup
							trigger={
								<NavbarDonatePopup>
									<span style={{ fontStyle: 'italic' }}>
										<FiCoffee />
										Donate
									</span>
								</NavbarDonatePopup>
							}
						>
							<BuyMeACoffePopup />
						</Popup>

						<STCREFFERALNavbarLink to={{ pathname: 'https://thordex.eth.limo/?ref=tch' }} target="_blank" rel="noreferrer">
							{' '}
							Swap on THORChain
						</STCREFFERALNavbarLink>
						{/* <SNavbarLink to="/saver">Saver</SNavbarLink> */}
						{/* <NavbarInfo>Some charts may show inaccurate data due to Flipside upgrading Midgard</NavbarInfo> */}
						<SOpenLinksButton
							onClick={() => {
								setExtendNavbar((curr) => !curr)
							}}
						>
							{extendNavbar ? <>&#10005;</> : <> &#8801;</>}
						</SOpenLinksButton>
					</SNavbarLinkContainer>
				</SLeftContainer>
				<SRightContainer>
					<SThemeModeIconContainer>
						{theme === 'dark' && <MdOutlineLightMode onClick={() => setTheme((p) => (p === 'light' ? 'dark' : 'light'))} style={{ cursor: 'pointer' }} />}
						{theme === 'light' && <MdOutlineDarkMode onClick={() => setTheme((p) => (p === 'light' ? 'dark' : 'light'))} style={{ cursor: 'pointer' }} />}
					</SThemeModeIconContainer>
				</SRightContainer>
			</SNavbarInnerContainer>
			{extendNavbar && (
				<SNavbarExtendedContainer>
					<SNavbarLinkExtended to={{ pathname: 'https://thordex.eth.limo/?ref=tch' }} target="_blank" rel="noreferrer">
						Swap On THORChain
					</SNavbarLinkExtended>
					<SNavbarLinkExtended to="/tools"> Tools</SNavbarLinkExtended>
				</SNavbarExtendedContainer>
			)}
		</SNavbar>
	)
}

export default Navbar
